
import DaisoImage from '~/components/common/DaisoImage.vue'
import DaisoVideo from '~/components/common/DaisoVideo.vue'
import { getCapturedUrl } from '~/utils/videoUtils'

export default {
  name: 'BannerMedia',
  components: { DaisoImage, DaisoVideo },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    imageSrcOverride: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    },
    resizeWidth: {
      type: [String, Number],
      default: '1280'
    },
    videoResizeWidth: {
      type: [String, Number],
      default: 480
    },
    imageClass: {
      type: String,
      default: ''
    },
    autoplay: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isVideo () {
      return this.item?.banrTypCd === '20'
    },
    videoSrc () {
      return this.item?.pcVideoAtchFileUrl || this.item?.mblVideoAtchFileUrl || ''
    },
    imageSrc () {
      return this.imageSrcOverride || this.item?.pcomIconAtchFileUrl || this.item?.mblIconAtchFileUrl || this.item?.pcThmnlAtchFileUrl || ''
    },
    videoOptions () {
      return {
        controls: false,
        autoplay: this.autoplay,
        muted: true,
        loop: true,
        playsinline: true,
        preload: 'auto',
        poster: getCapturedUrl(this.videoSrc, '850'),
        controlBar: {
          playToggle: false,
          pictureInPictureToggle: false,
          remainingTimeDisplay: false,
          progressControl: false,
          qualitySelector: false
        },
        playbackRates: [1]
      }
    }
  }
}
